<template>
  <div class="view">
    <h2>{{ article.articleTitle }}</h2>
    <div class="subtitle">{{ article.articleSources }}</div>
    <div class="info">
      发布日期：{{ article.createTimeString }} &nbsp;&nbsp;&nbsp;&nbsp;
      浏览次数：{{ article.viewTimes }}
    </div>
    <div class="separator"></div>
    <div class="content" v-html="article.articleContent"></div>
    <div class="attachment_list">
      <ul>
        <li v-for="item in article.attachmentList">
          <a :href="item.path">{{ item.fileName }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { apiService, RESULT_CODE } from "@/api/ApiService.js";
export default {
  name: "ArticleDetail",
  data: function() {
    return {
      article: {},
      articleId: ""
    };
  },
  mounted() {
    let { articleId } = this.$route.query;
    this.articleId = articleId;
    apiService.findArticleById(articleId).then(res => {
      this.article = res.data;
      // 图片高度自适应、文本自适应
      if (this.article.articleContent) {
        /* this.article.articleContent = this.article.articleContent.replaceAll(
          "<img",
          '<img style="max-width:100%;height:auto"'
        ); */
        this.article.articleContent = this.article.articleContent.replaceAll(
          "&lt;",
          "<"
        );
        this.article.articleContent = this.article.articleContent.replaceAll(
          "&gt;",
          ">"
        );
        // this.article.articleContent = this.article.articleContent.replaceAll(
        //   "text-indent: 2em;",
        //   ""
        // );
      }
      if (this.article && this.article.attachmentList) {
        this.article.attachmentList.forEach(element => {
          element.path = element.path.replace(
            "http://39.106.250.172:8080/",
            "https://www.ytysgz.com/"
          );
        });
      }
    });
    apiService.addViewTimes(articleId);
  }
};
</script>
<style scoped>
.view {
  padding: 0.25rem;
  background-color: #fff;
}

h2 {
  line-height: 0.2rem;
  text-align: center;
  font-size: 0.16rem;
}

.info {
  padding: 0.1rem 0;
  text-align: center;
  color: #999;
  font-size: 0.07rem;
}

.subtitle {
  text-align: center;
  font-size: 16px;
  line-height: 50px;
  color: rgb(34, 34, 34);
}

.separator {
  border-bottom: 1px dashed #e7e7e7;
  margin: 0.08rem;
}

.attachment_list ul {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.attachment_list ul > li {
  padding: 5px 10px;
  margin-right: 15px;
  border-radius: 5px;
}

.attachment_list ul > li > a {
  font-size: 14pt;
  line-height: 2;
  font-family: Arial;
  color: deepskyblue;
  text-decoration: none;
}

@media screen and (max-width: 768px) {
  .view {
    width: 100%;
    padding: 0.25rem 0;
  }
  p {
    max-width: 95% !important;
  }
  .content {
    padding: 0 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue